import * as R from 'ramda'
import Moment from 'moment'
import { projects, tasks, managers, properties } from './entities'
import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'
import { makePropSelector, filter, sort, currentSort, db, doc } from './common'
import { commentsByObjectID } from './index'
import {filteredCollection} from './filters'
import { attachmentsByObjectID } from './attachments'
import { createSearchAction, getSearchSelectors } from 'redux-search'

let taskFilters = state => state.taskFilters
let currentUser = state => state.session.userID

let taskStatus = (tasks, task) => {
	let status = "open"
	if (task.done) {
		status = "closed"
	} else if (R.any(dep => tasks[dep] && !tasks[dep].done, task.dependencies)) {
		status = "pending"
	} else if (task.urgent) {
		status = "urgent"
	}
	return status
}

let taskStatusOrdered = {	closed: '0closed', urgent: '1urgent', open: '2open', pending: '3pending' }

export let tasksByProjectID = createSelector(tasks, R.pipe(R.values, R.groupBy(R.prop('projectID'))))

export let openTasksByProjectID = createSelector(tasks, R.pipe(R.filter(task => !task.done), R.values, R.groupBy(R.prop('projectID'))))

export let projectTasks = createSelector(
	[tasksByProjectID, makePropSelector('projectID')]
  , (tasksByProjectID, projectID) => {
  		let tasks = tasksByProjectID[projectID]
		if (!tasks) return []
		return R.pipe(
			R.map(task => ({ ...task, status: taskStatus(tasks, task) }))
		  , R.sortWith([
				R.ascend(R.prop('status')),
				R.ascend(R.prop('_id'))
			])
		)(tasks)
	}
)

// export let tasksEx = (state) => tasks(state)
// export let tasksEx = createSelector(
// 	[filteredCollection('task'), db, commentsByObjectID, attachmentsByObjectID, sort('task', {secondary: 'project'})],
// 	(tasks, db, commentsByObjectID, attachmentsByObjectID, sort) =>{
//     	let extend = task => ({
// 			...task
// 		  , comments: commentsByObjectID[task._id] || []
// 		  , attachments: attachmentsByObjectID[task._id] || []
// 		})
// 		return R.pipe(R.map(extend), sort.fn)(tasks)
// 	}
// )
let sortOptions = (currentSort) => ({ secondary: currentSort.sortBy == 'status' ? 'project' : 'status' })

export let dependencies = createSelector(
	[tasksByProjectID, makePropSelector('projectID')]
  , (tasksByProjectID, projectID) =>{
	if(!tasksByProjectID[projectID]) return []
	tasksByProjectID[projectID]
	return R.pipe(
		R.map(task => ({ ...task, status: taskStatusOrdered[taskStatus(tasks, task)] }))
	  , R.sortWith([
			R.ascend(R.prop('status')),
			R.ascend(R.prop('_id'))
		])
	)(tasksByProjectID[projectID])
	}
)

export let tasksEx = createSelector(
	[filteredCollection('task'), db, currentUser, tasksByProjectID, properties, commentsByObjectID, attachmentsByObjectID, managers, sort('task', sortOptions)]
  , function (tasks, db, currentUser, tasksByProjectID, properties, commentsByObjectID, attachmentsByObjectID, managers, sort) {
		let extendTask = task => {
			let project = task.projectID && db[task.projectID]&& (db[task.projectID].title[0].toUpperCase()+db[task.projectID].title.slice(1)) || ""
			if (project){
				return({
					  ...task
				  , status: taskStatus(tasks, task)
				  , manager: task.managerID && managers[task.managerID] && managers[task.managerID].name
				  , project: project
				  , property:(task.propertyID && properties[task.propertyID])? properties[task.propertyID].alias:
						task.projectID && db[task.projectID] && db[task.projectID].propertyID?properties[db[task.projectID].propertyID]&&properties[db[task.projectID].propertyID].alias || "":""
				  , doneTime: (task.doneTime)? Moment(task.doneTime).format("MM/DD/YY") : undefined
				  , dependsOnEnded: (task.dependencies)? R.all((taskID) => (tasks[taskID])? tasks[taskID].done : true)(task.dependencies) : true
				  , comments: commentsByObjectID[task._id] || []
				  , taskType: task.taskType || "Admin"
				  , attachments: attachmentsByObjectID[task._id] || []
					, id: task._id
				})
			}
		}
		//let ex = extendTask(projects, tasks, properties, managers)
		return R.pipe(R.map(extendTask), R.filter(x=>x)/*, sort.fn*/)(tasks)
		// return R.map(extendTask)(tasks)
	}
  , 'tasksEx'
)

let {
	text
  , result // ids
  , unfilteredResult
} = getSearchSelectors({
	resourceName: 'task'
  , resourceSelector: (resourceName, state) => tasksEx(state)
})

export let tasksTable = createSelector(
	[tasksEx, text, result, unfilteredResult, sort('task', sortOptions)],
	(tasksEx, text, result, unfilteredResult, sort) => {
		// console.log("taskeTable", text, unfilteredResult, result, tasksEx);
		if(text) {
			// console.log("task tasksEx", tasksEx)
			// console.log("task text", text)
			// console.log("task result", result)
			tasksEx = R.filter(x=>x)(R.map(id => tasksEx[id], unfilteredResult))
			// console.log("task tasksEx MAPPED", tasksEx)
		}
		// else console.log('unfiltered tasks', sort.fn(tasksEx))
		return sort.fn(tasksEx)
 	}
 )



// WEBPACK FOOTER //
// ./src/selectors/tasks.js